module.exports = __webpack_public_path__ + "static/img/b101.d2a641a9.png";